class MediaGalleryV2 extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.currentIndex = 0;
    this.images = [];
    this.currentPage = 0;
    this.itemsPerPage = 6;
  }

  static get observedAttributes() {
    return ['images', 'data-images'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if ((name === 'images' || name === 'data-images') && newValue) {
      try {
        this.images = JSON.parse(newValue);
        console.log('Attribute changed - images:', this.images);
        console.log('Attribute changed - images length:', this.images.length);
        this.currentPage = 0;
        this.render();
      } catch (error) {
        console.error('Failed to parse images:', error);
      }
    }
  }

  connectedCallback() {
    const dataImages = this.getAttribute('data-images');
    let parsedImages = [];
    
    console.log('=== MediaGalleryV2 connectedCallback ===');
    console.log('dataImages:', dataImages);
    
    if (dataImages && dataImages.trim()) {
      try {
        parsedImages = JSON.parse(dataImages);
        console.log('parsedImages length:', parsedImages.length);
      } catch (error) {
        console.error('Failed to parse data-images:', error);
        parsedImages = [];
      }
    } else {
      console.log('No valid data-images attribute yet');
    }
    
    if (parsedImages && parsedImages.length > 0) {
      console.log('Using provided images');
      this.images = parsedImages;
    } else {
      console.log('No images available');
      this.images = [];
    }
    
    this.currentPage = 0;
    this.render();
  }
  
  render() {
    if (!this.images || this.images.length === 0) {
      this.shadowRoot.innerHTML = `
        <style>
          :host {
            display: block;
            width: 100%;
          }

          .media-gallery {
            position: relative;
            width: 100%;
          }

          .main-image-container {
            position: relative;
            width: 100%;
            overflow: hidden;
            aspect-ratio: 1 / 1;
            background-color: #f5f5f5;
            animation: pulse 2s ease-in-out infinite;
          }

          @media (max-width: 768px) {
            .main-image-container {
              aspect-ratio: auto;
              height: auto;
              max-height: 100vh;
            }
          }

          .thumbnails-wrapper {
            position: relative;
            margin-top: 15px;
          }

          .thumbnails-container {
            display: flex;
            gap: 10px;
            overflow: hidden;
            padding: 5px 40px;
          }

          .thumbnail {
            flex: 1;
            max-width: 80px;
            min-width: 60px;
            aspect-ratio: 4 / 3;
            border: 1px solid transparent;
            border-radius: 4px;
            cursor: pointer;
            overflow: hidden;
            padding: 5px;
            box-sizing: border-box;
            transition: border-color 0.3s ease;
            background-color: #f0f0f0;
            animation: pulse 2s ease-in-out infinite;
          }

          @keyframes pulse {
            0%, 100% {
              background-color: #f5f5f5;
            }
            50% {
              background-color: #e8e8e8;
            }
          }

          .thumbnail {
            animation-delay: calc(var(--index, 0) * 0.1s);
          }
        </style>
        <div class="media-gallery">
          <!-- Main Image Placeholder -->
          <div class="main-image-container"></div>

          <!-- Thumbnail Placeholders -->
          <div class="thumbnails-wrapper">
            <div class="thumbnails-container">
              ${Array.from({ length: 6 }, (_, i) => `
                <div class="thumbnail" style="--index: ${i}"></div>
              `).join('')}
            </div>
          </div>
        </div>
      `;
      return;
    }

    const totalPages = Math.ceil(this.images.length / this.itemsPerPage);
    const showPagination = this.images.length > this.itemsPerPage;
    const startIndex = this.currentPage * this.itemsPerPage;
    const endIndex = Math.min(startIndex + this.itemsPerPage, this.images.length);
    const currentImages = this.images.slice(startIndex, endIndex);

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          width: 100%;
        }

        .media-gallery {
          position: relative;
          width: 100%;
        }

        .main-image-container {
          position: relative;
          width: 100%;
          overflow: hidden;
          aspect-ratio: 1 / 1;
        }

        @media (max-width: 768px) {
          .main-image-container {
            aspect-ratio: auto;
            height: auto;
            max-height: 100vh;
          }
        }

        .main-image-slider {
          display: flex;
          width: 100%;
          height: 100%;
          transition: transform 0.5s ease;
        }

        .main-image-slide {
          flex: 0 0 100%;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .main-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        @media (max-width: 768px) {
          .main-image {
            height: auto;
            max-height: 80vh;
            object-fit: contain;
          }
        }

        .nav-buttons {
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          display: flex;
          justify-content: space-between;
          transform: translateY(-50%);
          pointer-events: none;
        }

        .nav-btn {
          width: var(--pagination-button-size, 45px);
          height: var(--pagination-button-size, 45px);
          display: inline-flex;
          justify-content: center;
          align-items: center;
          border-radius: var(--pagination-button-border-radius, 4px);
          border: none;
          background-color: var(--pagination-button-background, rgba(255, 255, 255, 1));
          color: var(--pagination-button-color, rgb(var(--color-foreground)));
          transition: var(--pagination-button-transition, 0.25s all);
          pointer-events: auto;
          opacity: 0;
          visibility: hidden;
          transform: translate3d(-100%, 0, 0);
          cursor: pointer;
          box-shadow: var(--pagination-button-shadow, none);
        }

        .nav-btn.swiper-button-next {
          transform: translate3d(100%, 0, 0);
        }

        .main-image-container:hover .nav-btn {
          opacity: 1;
          visibility: visible;
          transform: translate3d(0, 0, 0);
        }

        .main-image-container:hover .nav-btn.swiper-button-next {
          transform: translate3d(0, 0, 0);
        }

        .nav-btn:hover {
          background-color: var(--pagination-button-background-hover, rgb(var(--color-foreground)));
          color: var(--pagination-button-color, rgb(var(--color-background)));
          border-color: rgb(var(--color-border));
          box-shadow: var(--pagination-button-shadow-hover, none);
          transform: translate3d(0, -2px, 0);
        }

        .nav-btn.swiper-button-next:hover {
          transform: translate3d(0, -2px, 0);
        }

        .nav-btn svg {
          width: var(--pagination-button-icon-size, 20px);
          height: var(--pagination-button-icon-size, 20px);
          fill: var(--pagination-button-color, rgb(var(--color-foreground)));
        }
        .nav-btn:hover svg {
          fill: var(--pagination-button-color, rgb(var(--color-background)));
        }

        .thumbnails-wrapper {
          position: relative;
          margin-top: 15px;
        }

        .thumbnails-container {
          display: flex;
          gap: 10px;
          overflow: hidden;
          padding: 5px 40px;
        }

        .thumbnail {
          flex: 1;
          max-width: 88px;
          min-width: 66px;
          aspect-ratio: 4 / 3;
          border: 1px solid transparent;
          border-radius: 4px;
          cursor: pointer;
          overflow: hidden;
          padding: 5px;
          box-sizing: border-box;
          transition: border-color 0.3s ease;
        }

        .thumbnail.active {
          border-color: rgb(var(--color-foreground));
        }

        .thumbnail img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .thumbnails-nav {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: var(--pagination-button-size, 30px);
          height: var(--pagination-button-size, 30px);
          display: ${showPagination ? 'flex' : 'none'};
          justify-content: center;
          align-items: center;
          border-radius: var(--pagination-button-border-radius, 4px);
          border: none;
          background-color: var(--pagination-button-background, rgba(255, 255, 255, 1));
          color: var(--pagination-button-color, rgb(var(--color-foreground)));
          transition: var(--pagination-button-transition, 0.25s all);
          cursor: pointer;
          z-index: 10;
          box-shadow: var(--pagination-button-shadow, none);
        }

        .thumbnails-nav:hover {
          background-color: var(--pagination-button-background-hover, rgb(var(--color-foreground)));
          border-color: rgb(var(--color-border));
          box-shadow: var(--pagination-button-shadow-hover, none);
          transform: translateY(-50%) translateY(-2px);
        }

        .thumbnails-nav:hover svg {
          fill: var(--pagination-button-color, rgb(var(--color-background)));
        }

        .thumbnails-nav.prev {
          left: 0;
        }

        .thumbnails-nav.next {
          right: 0;
        }

        .thumbnails-nav.disabled {
          opacity: 0.3;
          cursor: not-allowed;
          transform: translateY(-50%);
        }

        .thumbnails-nav.disabled:hover {
          background-color: var(--pagination-button-background, rgba(255, 255, 255, 1));
          transform: translateY(-50%);
        }

        .thumbnails-nav.disabled:hover svg {
          fill: var(--pagination-button-color, rgb(var(--color-foreground)));
        }

        .thumbnails-nav svg {
          width: var(--pagination-button-icon-size, 16px);
          height: var(--pagination-button-icon-size, 16px);
          fill: var(--pagination-button-color, rgb(var(--color-foreground)));
        }

        .ul-certified {
          position: absolute;
          top: 15px;
          right: 15px;
          z-index: 10;
        }

        .ul-certified svg {
          width: 50px;
          height: 50px;
        }

        @media (max-width: 768px) {
          .thumbnails-wrapper {
            margin-top: 10px;
            padding: 0 15px;
          }

          .thumbnails-nav {
            display: none !important;
          }

          .thumbnails-container {
            padding: 5px 0 !important;
            overflow-x: auto !important;
            overflow-y: hidden !important;
            scroll-snap-type: x mandatory;
            -webkit-overflow-scrolling: touch;
          }

          .thumbnails-container::-webkit-scrollbar {
            display: none;
          }

          .thumbnails-container {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }

          .thumbnail {
            scroll-snap-align: start;
            flex-shrink: 0 !important;
            flex: 0 0 auto !important;
            max-width: 88px;
            min-width: 66px;
          }
        }
      </style>

      <div class="media-gallery">
        <!-- Main Image Slider -->
        <div class="main-image-container">
          <div class="main-image-slider" id="main-image-slider">
            ${this.images.map((image) => `
              <div class="main-image-slide">
                <img 
                  src="${image.src}" 
                  alt="${image.alt || ''}"
                  class="main-image"
                >
              </div>
            `).join('')}
          </div>
          
          <!-- Navigation Buttons -->
          <div class="nav-buttons">
            <button class="nav-btn swiper-button-control" id="prev-btn">
              <svg viewBox="0 0 24 24">
                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
              </svg>
            </button>
            <button class="nav-btn swiper-button-control swiper-button-next" id="next-btn">
              <svg viewBox="0 0 24 24">
                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
              </svg>
            </button>
          </div>
        </div>

        <!-- Thumbnail Gallery -->
        <div class="thumbnails-wrapper">
          <button class="thumbnails-nav prev ${this.currentPage === 0 ? 'disabled' : ''}" id="thumb-prev-btn">
            <svg viewBox="0 0 24 24">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
            </svg>
          </button>
          <div class="thumbnails-container" id="thumbnails-container">
            ${currentImages.map((image, index) => `
              <div class="thumbnail ${startIndex + index === this.currentIndex ? 'active' : ''}" data-index="${startIndex + index}">
                <img 
                  src="${image.thumbSrc || image.src}" 
                  alt="${image.alt || ''}"
                >
              </div>
            `).join('')}
          </div>
          <button class="thumbnails-nav next ${this.currentPage >= totalPages - 1 ? 'disabled' : ''}" id="thumb-next-btn">
            <svg viewBox="0 0 24 24">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
            </svg>
          </button>
        </div>
      </div>
    `;

    this.addEventListeners();
    this.updateSliderPosition();
  }

  addEventListeners() {
    // Thumbnail clicks
    const thumbnails = this.shadowRoot.querySelectorAll('.thumbnail');
    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', (e) => {
        const index = parseInt(e.currentTarget.dataset.index);
        this.goToSlide(index);
      });
    });

    // Main image navigation buttons
    const prevBtn = this.shadowRoot.getElementById('prev-btn');
    const nextBtn = this.shadowRoot.getElementById('next-btn');

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
        this.goToSlide(this.currentIndex);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
        this.goToSlide(this.currentIndex);
      });
    }

    // Thumbnail pagination buttons
    const thumbPrevBtn = this.shadowRoot.getElementById('thumb-prev-btn');
    const thumbNextBtn = this.shadowRoot.getElementById('thumb-next-btn');

    if (thumbPrevBtn) {
      thumbPrevBtn.addEventListener('click', () => {
        if (this.currentPage > 0) {
          this.currentPage--;
          this.render();
        }
      });
    }

    if (thumbNextBtn) {
      thumbNextBtn.addEventListener('click', () => {
        const totalPages = Math.ceil(this.images.length / this.itemsPerPage);
        if (this.currentPage < totalPages - 1) {
          this.currentPage++;
          this.render();
        }
      });
    }
  }

  goToSlide(index) {
    this.currentIndex = index;
    const newPage = Math.floor(index / this.itemsPerPage);
    if (newPage !== this.currentPage) {
      this.currentPage = newPage;
      this.render();
    } else {
      this.updateSliderPosition();
      this.updateThumbnailActiveState();
    }
  }

  updateSliderPosition() {
    const slider = this.shadowRoot.getElementById('main-image-slider');
    if (slider) {
      const translateX = -this.currentIndex * 100;
      slider.style.transform = `translateX(${translateX}%)`;
    }
  }

  updateThumbnailActiveState() {
    const thumbnails = this.shadowRoot.querySelectorAll('.thumbnail');
    thumbnails.forEach((thumb) => {
      const thumbIndex = parseInt(thumb.dataset.index);
      thumb.classList.toggle('active', thumbIndex === this.currentIndex);
    });
  }
}

// Define the custom element
customElements.define('media-gallery-v2', MediaGalleryV2);